<template>
  <Toast />
  <router-view />
</template>

<script>
import Toast from "primevue/toast";

export default {
  components: { Toast },
  mounted() {
    this.$emitter.on("toast", this.createToast);
  },
  methods: {
    createToast({ severity, message }) {
      this.$toast.add({
        severity: severity,
        detail: this.$t(message),
        life: 4000,
      });
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/buttons";
@import "assets/scss/forms.scss";
@import "assets/scss/loader.scss";
@import "assets/scss/tables.scss";
@import "assets/scss/tabs.scss";
@import "assets/scss/text.scss";
@import "assets/scss/container.scss";

::-ms-reveal {
  display: none;
}

.p-toast {
  width: auto;
  max-width: 30rem;
}
</style>
